/*
 * @Descripttion: main
 * @FilePath: /mall-wap-vue/src/main.js
 * @Author: 张兴业
 * @Date: 2020-09-24 10:19:31
 * @LastEditors: hl
 * @LastEditTime: 2024-11-26 17:44:59
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vant/lib/index.css";
import "@/assets/style/common.css";
import VueClipboard from "vue-clipboard2";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
// import "swiper/css/swiper.css";

// import "@/utils/rem.js";
import "amfe-flexible";

import "./permission";

import "@/utils/mixin.js";

// muse-ui
import "muse-ui/lib/styles/base.less";
import { Picker, Paper } from "muse-ui";
import "muse-ui/dist/muse-ui.css";

import { initGlobal } from "./global";
import * as filters from "./filters";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.prototype.$currency = filters.currency;
Vue.prototype.$dateFormatterJava = filters.dateFormatterJava;
initGlobal();

// export { dateFormatterJava } from "@/utils";
// Vue.filter("dateFormatterJava", dateFormatterJava.format);

Vue.use(Picker);
Vue.use(Paper);
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import {
  Button,
  Tabbar,
  TabbarItem,
  Lazyload,
  Swipe,
  SwipeItem,
  Field,
  Divider,
  RadioGroup,
  Radio,
  Image as VanImage,
  DatetimePicker,
  Overlay,
  Popup,
  DropdownMenu,
  DropdownItem,
  Icon,
  Form,
  CountDown,
  Uploader,
  ImagePreview,
  Step,
  Steps,
  Collapse,
  CollapseItem,
  ActionSheet,
  Sticky,
  List,
  Stepper,
  PullRefresh,
  Tag,
  Dialog,
  Sku,
  Checkbox,
  CheckboxGroup,
  Cell,
  CellGroup,
  Switch,
  SubmitBar
} from "vant";

Vue.use(Button);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Field);
Vue.use(Divider);
Vue.use(VanImage);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DatetimePicker);
Vue.use(Overlay);
Vue.use(Popup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Icon);
Vue.use(Form);
Vue.use(CountDown);
Vue.use(Uploader);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(ActionSheet);
Vue.use(Sticky);
Vue.use(List);
Vue.use(Stepper);
Vue.use(PullRefresh);
Vue.use(Tag);
Vue.use(Sku);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Dialog);
Vue.use(Switch);
Vue.use(SubmitBar);
Vue.use(ImagePreview);
Vue.use(Lazyload, {
  lazyComponent: true
});
Vue.use(VueClipboard);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
